module.exports = __webpack_public_path__ + "static/media/gradient01.0df15001.jpg";